import { useContext } from 'react';
import { SkeletonBreadcrumbs } from '@/components/presentation/Breadcrumbs';
import { WorkspaceBreadcrumbsContext } from '@/containers/WorkspaceObject';
import styles from './style/Header.module.css';
import WorkspaceObjectBreadcrumbs from '@/components/Workspace/ObjectBreadcrumbs';

type Props = {
  isLoading: boolean;
};

export const FileBreadcrumbs = ({ isLoading }: Props) => {
  const breadcrumbs = useContext(WorkspaceBreadcrumbsContext);

  return (
    <>
      {isLoading
        ? <SkeletonBreadcrumbs />
        : (
          <div className={styles.breadcrumbs}>
            <WorkspaceObjectBreadcrumbs items={breadcrumbs} />
          </div>
        )
      }
    </>
  );
};